import { cn } from '@/hen-ui/utils';
import type { StudentLoansBannerLayout } from './types';

export function studentLoansBannerCardContentClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn('gap-md p-md', layout === 'mobile' && 'gap-lg p-lg');
}

export function studentLoansBannerBadgeClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn(
    'inline-flex w-fit items-center gap-xxs px-xs',
    layout === 'mobile' && 'w-full max-w-none justify-start gap-min px-sm',
  );
}

export function studentLoansBannerRootClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn('flex w-full flex-col gap-md', layout === 'mobile' && 'gap-lg');
}

export function studentLoansBannerMainRowClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn(
    'flex w-full min-w-0',
    layout === 'mobile'
      ? 'flex-col flex-nowrap items-stretch gap-xl'
      : 'flex-row flex-wrap items-center gap-lg',
  );
}

export function studentLoansBannerPartnerClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn(
    'min-w-0 shrink-0 gap-xxs pr-sm',
    layout === 'mobile' && 'gap-xs pr-0',
  );
}

export function studentLoansBannerBulletsClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn('min-w-0 flex-1 gap-xxs', layout === 'mobile' && 'w-full gap-xs');
}

export function studentLoansBannerBulletsContainerClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn(
    layout === 'fullWidth' && 'min-w-0 flex-1 md:flex md:flex-row md:gap-x-xl',
  );
}

export function studentLoansBannerBulletsColumnClasses(): string {
  return 'min-w-0 flex-1 gap-xxs';
}

export function studentLoansBannerCtaButtonClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn(layout === 'mobile' && 'w-full text-b4 leading-b4');
}

export function studentLoansBannerCtaColumnClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn(
    'flex shrink-0 flex-col items-center gap-xxs',
    layout === 'mobile' && 'w-full items-stretch gap-xs',
  );
}

export function studentLoansBannerDataPointsClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn(
    'flex w-full flex-wrap justify-between gap-y-md',
    layout === 'mobile' && 'grid grid-cols-2 gap-x-sm gap-y-md',
  );
}

export function studentLoansBannerDisclosureRowClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn(
    'flex w-full gap-md',
    layout === 'mobile'
      ? 'flex-col items-stretch gap-lg'
      : 'flex-row flex-wrap items-center justify-between',
  );
}

export function studentLoansBannerDisclosureTextClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn('min-w-0', layout === 'mobile' ? 'w-full' : 'flex-1');
}

export function studentLoansBannerLearnMoreClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn(
    'inline-flex shrink-0 items-center gap-xxs',
    layout === 'mobile' && 'w-full justify-start',
  );
}

export function studentLoansBannerDataPointRowClasses(
  layout: StudentLoansBannerLayout,
): string {
  return cn('min-w-0 px-xs', layout === 'mobile' && 'pl-sm pr-0');
}

export const studentLoansBannerSeparatorClasses = 'bg-neutral-200';
